import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import get from 'lodash/get';
import { Breadcrumb, Button, Tabs, Tooltip, message } from 'antd';

import Table from 'components/Table';
import { elipsis } from 'shared/utils/StringUtil';
// import { addParamPageURL, getParamURL } from 'shared/utils/UrlUtil';
import { permissionService } from 'shared/services';
import { userPermissions, FILTER_TYPE, paginationParam } from 'shared/constant';
import NewFilter from 'components/NewFilter';

import organizationRoute from '../../route';

import text from './EmployeeList.page.translation';
import './EmployeeList.style.less';

const { TabPane } = Tabs;

const viewCompanyTabKey = 'view-company';
const viewAllTabKey = 'view-all';

class EmployeeList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTabKey: this.props.match.params.tab || viewCompanyTabKey,
    };

    const { resetFilter, match } = this.props;
    if (!match.params.page) {
      resetFilter();
    }
  }

  componentDidMount() {
    this.refreshEmployeeTable();
  }

  refreshEmployeeTable = () => {
    const { match, filterValue } = this.props;

    if (match.params.page) {
      this.updateEmployeeTable(filterValue);
    } else {
      this.updateEmployeeTable([]);
    }
  };

  componentDidUpdate(prevProps) {
    const { formControlShow, match, filterValue } = this.props;
    let canUpdateEmployeeTable = true;

    if (
      prevProps.match.params.page !== match.params.page ||
      prevProps.match.params.tab !== this.props.match.params.tab
    ) {
      canUpdateEmployeeTable = false;
      this.updateEmployeeTable(filterValue);
    }

    if (prevProps.filterValue !== filterValue && !formControlShow) {
      if (
        !(
          prevProps.filterValue.length > 0 &&
          prevProps.filterValue.length > filterValue.length &&
          prevProps.filterValue[prevProps.filterValue.length - 1].inputValue
            .length === 0
        )
      ) {
        if (
          prevProps.match.params.page !== match.params.page ||
          (prevProps.match.params.page === match.params.page &&
            match.params.page > 1)
        ) {
          this._handleChangePage(1);
        } else if (canUpdateEmployeeTable) {
          this.updateEmployeeTable(filterValue);
        }
      }
    }
  }

  _handleChangePage = page => {
    const { history } = this.props;

    const url = organizationRoute.EMPLOYEE_LIST_FILTER.replace(
      ':tab',
      this.state.activeTabKey,
    ).replace(':page', page);
    history.push(url);
  };

  _renderNoColumn = (pageNum, pageSize) => (_text, _record, index) => {
    const result = index + 1 + pageSize * (pageNum - 1);
    return result;
  };

  _openEmployeeDetail = record => () => {
    this.props.history.push(
      organizationRoute.EMPLOYEE_DETAIL.replace(':id', record.employee_id),
    );
  };

  _renderEmployeeName = record => {
    const firstname = get(record, 'firstname', '');
    const lastname = get(record, 'lastname', '');

    const employeeName = `${firstname} ${lastname}`;

    return (
      <button
        type="button"
        className="btn-details left-text"
        onClick={this._openEmployeeDetail(record)}
      >
        <Tooltip placement="topLeft" title={employeeName}>
          <span>{elipsis(employeeName, 30)}</span>
        </Tooltip>
      </button>
    );
  };

  _openCompanyDetail = record => () => {
    this.props.history.push(
      organizationRoute.COMPANY_DETAIL.replace(
        ':id',
        record.organization_details.organization_id,
      ),
    );
  };

  _renderCompanyName = canReadCompany => record => {
    const companyName = get(record, 'organization_details.name', '');

    if (canReadCompany) {
      return (
        <button
          type="button"
          className="btn-details left-text"
          onClick={this._openCompanyDetail(record)}
        >
          <Tooltip placement="topLeft" title={companyName}>
            <span>{elipsis(companyName, 30)}</span>
          </Tooltip>
        </button>
      );
    }

    return (
      <Tooltip placement="topLeft" title={companyName}>
        <span>{elipsis(companyName, 30)}</span>
      </Tooltip>
    );
  };

  _renderRoleColumn = record => {
    const {
      user_details: { user_role: roles },
    } = record;
    let employee = '-';
    if (get(roles, 'length')) {
      roles.forEach((role, index) => {
        if (index > 0) {
          employee += `, ${role.name}`;
        } else {
          employee = role.name;
        }
      });
    }

    return (
      <Tooltip title={employee}>
        <span>{elipsis(employee, 30)}</span>
      </Tooltip>
    );
  };

  _onStatusChange = record => () => {
    this.props.setEmployeeStatus(
      record.user_details.user_id,
      record.user_details.blocked,
      this._setEmployeeStatusCallback,
    );
  };

  _setEmployeeStatusCallback = prevStatusDeactivated => {
    const {
      intl: { formatMessage },
    } = this.props;

    if (prevStatusDeactivated) {
      message.success(formatMessage(text.notifActivatedSuccess));
    } else {
      message.success(formatMessage(text.notifDeactivatedSuccess));
    }

    this.refreshEmployeeTable();
  };

  _getRecordStatusText = record => {
    if (record.user_details.blocked) {
      return {
        text: 'Deactive',
        style: 'status-col deactivated',
      };
    }
    return {
      text: 'Active',
      style: 'status-col activated',
    };
  };

  _renderCurrentStatus = record => {
    const recordStatus = this._getRecordStatusText(record);

    return <label className={recordStatus.style}>{recordStatus.text}</label>;
  };

  _getRecordStatusAction = record => {
    if (record.user_details.blocked) {
      return {
        text: 'Activate',
        type: 'primary',
      };
    }
    return {
      text: 'Deactivate',
      type: 'danger',
    };
  };

  _renderStatusColumn = record => {
    const recordStatus = this._getRecordStatusAction(record);

    return (
      <Button type={recordStatus.type} onClick={this._onStatusChange(record)}>
        {recordStatus.text}
      </Button>
    );
  };

  _checkChangeActivation = () => {
    const { checkPermission } = permissionService;
    const { activeTabKey } = this.state;
    const { me } = this.props;

    const isPIC = get(me, 'user_details.user_metadata.pic', false);
    const isSuper = get(me, 'user_details.user_metadata.super_admin', false);
    const canEditEmployee =
      (isSuper || (isPIC && activeTabKey === viewCompanyTabKey)) &&
      checkPermission(userPermissions.UPDATE_EMPLOYEE, true);

    return canEditEmployee;
  };

  _tableColumns = (pageNum, pageSize) => {
    const {
      intl: { formatMessage },
    } = this.props;

    const canReadCompany = permissionService.checkPermission(
      userPermissions.READ_COMPANY,
      true,
    );

    const result = [
      {
        title: formatMessage(text.no),
        key: 'index',
        render: this._renderNoColumn(pageNum, pageSize),
        width: 100,
      },
      {
        title: formatMessage(text.employeeName),
        key: 'firstname',
        render: this._renderEmployeeName,
        width: 300,
      },
      {
        title: formatMessage(text.companyName),
        key: 'company',
        render: this._renderCompanyName(canReadCompany),
        width: 300,
      },
      {
        title: formatMessage(text.email),
        dataIndex: 'user_details.email',
        key: 'email',
        width: 300,
      },
      {
        title: formatMessage(text.role),
        render: this._renderRoleColumn,
        key: 'role',
        width: 300,
      },
      {
        title: formatMessage(text.ktp),
        dataIndex: 'ktp_num',
        key: 'ktp_num',
        width: 300,
      },
      {
        title: formatMessage(text.currentStatus),
        key: 'currentStatus',
        render: this._renderCurrentStatus,
        width: 200,
      },
    ];

    const canEditEmployee = this._checkChangeActivation();

    if (canEditEmployee) {
      result.push({
        title: formatMessage(text.action),
        key: 'action',
        render: this._renderStatusColumn,
        width: 150,
      });
    }

    return result;
  };

  _renderAgentRegisterBtn = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <Button
        type="primary"
        block
        className="btn register-vendor-btn"
        htmlType="submit"
      >
        <Link to={organizationRoute.EMPLOYEE_REGISTER}>
          {formatMessage(text.btnRegister)}
        </Link>
      </Button>
    );
  };

  _getRowId = row => row.employee_id;

  getColumnsScrollX = columns => {
    const result = columns
      .map(x => x.width)
      .reduce((prev, next) => prev + next);
    return result;
  };

  _renderTable = () => {
    const { listEmployee, employeeFilter, getLoading } = this.props;

    const pageSize = get(employeeFilter, 'page_size');
    const pageCount = get(employeeFilter, 'page_count');
    const pageNum = get(employeeFilter, 'page_num');
    const totalItem = pageSize * pageCount;

    const tableColumns = this._tableColumns(pageNum, pageSize);
    const scrollX = this.getColumnsScrollX(tableColumns);

    return (
      <Table
        columns={tableColumns}
        dataSource={listEmployee}
        bordered={false}
        pagination="true"
        rowKey={this._getRowId}
        rowClass="striped-table"
        loadingValue={getLoading}
        totalItem={totalItem}
        currentPage={pageNum}
        changePage={this._handleChangePage}
        scrollX={scrollX}
      />
    );
  };

  _renderFilter = () => {
    const {
      intl: { formatMessage },
    } = this.props;

    const options = [
      {
        label: formatMessage(text.employeeName),
        value: 'fullname',
        type: FILTER_TYPE.TEXT,
      },
    ];

    return <NewFilter options={options} />;
  };

  onChangeTab = activeKey => {
    this.setState(
      {
        activeTabKey: activeKey,
      },
      this.onChangeTabCallback,
    );
  };

  onChangeTabCallback = () => {
    this.props.resetFilter();

    let setURLtab;
    if (this.state.activeTabKey === viewCompanyTabKey) {
      setURLtab = viewCompanyTabKey;
    } else {
      setURLtab = viewAllTabKey;
    }

    this.props.history.push(
      organizationRoute.EMPLOYEE_LIST_FILTER.replace(':tab', setURLtab).replace(
        ':page',
        1,
      ),
    );
  };

  buildGetParamUrl = filterValue => {
    let result = '';

    filterValue.forEach(element => {
      const value = element.inputValue[0];
      switch (element.key) {
        default:
          result += `&${element.key}=${value}`;
          break;
      }
    });

    return result;
  };

  buildPaginationUrl = employeeFilter => {
    let result = '';
    result += `page_size=${encodeURIComponent(employeeFilter.page_size)}`;
    result += `&page_count=${encodeURIComponent(employeeFilter.page_count)}`;
    result += `&page_num=${encodeURIComponent(employeeFilter.page_num)}`;

    return result;
  };

  updateEmployeeTable = filterValue => {
    const { employeeFilter, match, history, viewAll } = this.props;

    let paginationValue = { ...paginationParam };

    let canViewAll = false;
    if (
      get(viewAll, 'Organization') &&
      this.state.activeTabKey === viewAllTabKey
    ) {
      canViewAll = true;
    }

    // auto include view_all param
    let paramUrl = `&view_all=${canViewAll}`;

    const page = get(match, 'params.page', '');
    const pageInt = parseInt(page, 10) || '';

    if (filterValue.length > 0) {
      paramUrl += this.buildGetParamUrl(filterValue);
    }

    if (page) {
      if (pageInt && pageInt >= 1) {
        paginationValue = {
          ...employeeFilter,
          page_num: pageInt,
        };
        const paginationUrl = this.buildPaginationUrl(paginationValue);
        this.getListEmployee(paginationUrl, paramUrl);
      } else {
        history.push(organizationRoute.EMPLOYEE_LIST);
      }
    } else {
      const paginationUrl = this.buildPaginationUrl(paginationValue);
      this.getListEmployee(paginationUrl, paramUrl);
    }
  };

  getListEmployee = (paginationUrl, paramUrl) => {
    const { getLoading, getListEmployee } = this.props;

    if (!getLoading) {
      getListEmployee(paginationUrl, paramUrl);
    }
  };

  render() {
    const {
      intl: { formatMessage },
      viewAll,
      getLoading,
    } = this.props;

    const canViewAll = get(viewAll, 'Organization');
    const canCreateEmployee = permissionService.checkPermission(
      userPermissions.CREATE_EMPLOYEE,
      true,
    );

    return (
      <div className="main-content">
        <div className="breadcrumb-wrapper">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/">Home</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              {formatMessage(text.employeeList)}
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className="white-box-wrapper">
          <span className="title mbottom30">
            {formatMessage(text.employeeList)}
          </span>

          {canCreateEmployee && this._renderAgentRegisterBtn()}
          {this._renderFilter()}

          <div className="table-wrapper">
            <Tabs
              tabBarStyle={{ margin: '0px' }}
              type="card"
              onChange={this.onChangeTab}
              activeKey={this.state.activeTabKey}
            >
              <TabPane
                disabled={getLoading}
                tab="View Company"
                key={viewCompanyTabKey}
              ></TabPane>
              {canViewAll ? (
                <TabPane
                  disabled={getLoading}
                  tab="View All"
                  key={viewAllTabKey}
                ></TabPane>
              ) : null}
            </Tabs>
            {this._renderTable()}
          </div>
        </div>
      </div>
    );
  }
}

EmployeeList.propTypes = {
  history: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  // location: PropTypes.object.isRequired,
  getListEmployee: PropTypes.func.isRequired,
  setEmployeeStatus: PropTypes.func,
  listEmployee: PropTypes.array,
  getLoading: PropTypes.bool,
  viewAll: PropTypes.object,
  me: PropTypes.object,
  resetFilter: PropTypes.func,
  employeeFilter: PropTypes.object,
  filterValue: PropTypes.array,
  formControlShow: PropTypes.bool,
  match: PropTypes.object,
};

export default EmployeeList;
